// import React from 'react';
// import './App.css';
// import * as d3 from 'd3';
// import dat from './pollsData.csv';

// export default class PollsChart extends React.Component {
//     constructor(props) {
//         super(props);
//         this.myRef = React.createRef();
//         this.state = {csvData : null,
//                     from: props.from,
//                     to: props.to,
//                     period: props.period}
//     }

//     componentDidMount(){
//         this.drawChart();
//     }

//     loadData(){
//         d3.csv(dat).then(function(data){
//             console.log(data);
//             var allGroup = ["ProductManagement", "HumanResources", "Marketing", "Data", "Development"];
//             var dataReady = allGroup.map(function(grpName){
//                 return {
//                     name: grpName,
//                     values: data.map(function(d) {
//                         return {date: d.date, value: +d[grpName]};
//                     })
//                 }
//             })
//             console.log(dataReady);
//             this.setState({csvData: dataReady});
//         })
//     }

//     drawChart(){
//         const w = 860;
//         const h = 600;
//         const margin = {top:50, right:40, bottom:135, left:110};
//         const innerHeight = h - margin.top - margin.bottom;
//         const innerWidth = w - margin.left - margin.right;

//         const accessToRef = d3.select(this.myRef.current)
//             .append('svg')
//             .attr('width', '100%')
//             .attr('height', h)
//             // .style('padding', 50)
//             // .style('margin-top', 50)
//             // .style('background-color', 'blue');
        
//         const g = accessToRef.append('g')
//             .attr('transform', `translate(${margin.left}, ${margin.top})`);

//         // this.loadData();
//         var dataR = [
//             {
//                 name: "Product Management",
//                 values: [
//                     {date: "2020-06-01", value: 0},
//                     {date: "2020-06-08", value: 1},
//                     {date: "2020-06-15", value: 1},
//                     {date: "2020-06-22", value: 3},
//                     {date: "2020-07-29", value: 4},
//                     {date: "2020-07-06", value: 4},
//                     {date: "2020-07-13", value: 4},
//                     {date: "2020-07-20", value: 6},
//                     {date: "2020-07-27", value: 9},
//                     {date: "2020-08-03", value: 3},
//                     {date: "2020-08-10", value: 2},
//                     {date: "2020-08-17", value: 4},
//                     {date: "2020-08-24", value: 4},
//                     {date: "2020-08-31", value: 8}
//                 ]
//             },
//             {
//                 name: "Human Resources",
//                 values: [
//                     {date: "2020-06-01", value: 3},
//                     {date: "2020-06-08", value: 4},
//                     {date: "2020-06-15", value: 5},
//                     {date: "2020-06-22", value: 6},
//                     {date: "2020-07-29", value: 6},
//                     {date: "2020-07-06", value: 6},
//                     {date: "2020-07-13", value: 9},
//                     {date: "2020-07-20", value: 11},
//                     {date: "2020-07-27", value: 8},
//                     {date: "2020-08-03", value: 7},
//                     {date: "2020-08-10", value: 3},
//                     {date: "2020-08-17", value: 6},
//                     {date: "2020-08-24", value: 2},
//                     {date: "2020-08-31", value: 3}
//                 ]
//             },
//             {
//                 name: "Marketing",
//                 values: [
//                     {date: "2020-06-01", value: 0},
//                     {date: "2020-06-08", value: 0},
//                     {date: "2020-06-15", value: 0},
//                     {date: "2020-06-22", value: 0},
//                     {date: "2020-07-29", value: 2},
//                     {date: "2020-07-06", value: 2},
//                     {date: "2020-07-13", value: 1},
//                     {date: "2020-07-20", value: 3},
//                     {date: "2020-07-27", value: 3},
//                     {date: "2020-08-03", value: 2},
//                     {date: "2020-08-10", value: 2},
//                     {date: "2020-08-17", value: 5},
//                     {date: "2020-08-24", value: 5},
//                     {date: "2020-08-31", value: 1}
//                 ]
//             },
//             {
//                 name: "Data",
//                 values: [
//                     {date: "2020-06-01", value: 1},
//                     {date: "2020-06-08", value: 1},
//                     {date: "2020-06-15", value: 1},
//                     {date: "2020-06-22", value: 2},
//                     {date: "2020-07-29", value: 2},
//                     {date: "2020-07-06", value: 5},
//                     {date: "2020-07-13", value: 4},
//                     {date: "2020-07-20", value: 3},
//                     {date: "2020-07-27", value: 2},
//                     {date: "2020-08-03", value: 5},
//                     {date: "2020-08-10", value: 5},
//                     {date: "2020-08-17", value: 5},
//                     {date: "2020-08-24", value: 2},
//                     {date: "2020-08-31", value: 2}
//                 ]
//             },
//             {
//                 name: "Development",
//                 values: [
//                     {date: "2020-06-01", value: 0},
//                     {date: "2020-06-08", value: 1},
//                     {date: "2020-06-15", value: 3},
//                     {date: "2020-06-22", value: 5},
//                     {date: "2020-07-29", value: 3},
//                     {date: "2020-07-06", value: 2},
//                     {date: "2020-07-13", value: 1},
//                     {date: "2020-07-20", value: 0},
//                     {date: "2020-07-27", value: 2},
//                     {date: "2020-08-03", value: 3},
//                     {date: "2020-08-10", value: 8},
//                     {date: "2020-08-17", value: 5},
//                     {date: "2020-08-24", value: 3},
//                     {date: "2020-08-31", value: 6}
//                 ]
//             }
//         ]


//         var dataReady = []
//         var toDate;
//         var fromDate;

//         if(this.state.period !== ''){
//             var today = new Date();
//             var dd = String(today.getDate()).padStart(2, '0');
//             var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
//             var yyyy = today.getFullYear();
//             today = yyyy + '-' + mm + '-' + dd;
//             const date = new Date(today)
//             const dateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: '2-digit' }) 
//             const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat.formatToParts(date )
//             toDate = `${month} ${day} ${year}`
//             var prevDate = ''
//             switch(this.state.period){
//                 case 1:
//                     prevDate = new Date(today)
//                     prevDate.setMonth(prevDate.getMonth() - 3)
//                     break;
//                 case 2:
//                     prevDate = new Date(today)
//                     prevDate.setMonth(prevDate.getMonth() - 6)
//                     break;
//                 case 3:
//                     prevDate = new Date(today)
//                     prevDate.setMonth(prevDate.getMonth() - 9)
//                     break;
//                 case 4:
//                     prevDate = new Date(today)
//                     prevDate.setMonth(prevDate.getMonth() - 12)
//                     break;
//                 default:
//                     console.log('Date not parsed!')
//                     break;
//             }
//             const tempdate = new Date(prevDate)
//             const prevdateTimeFormat = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: '2-digit' }) 
//             const [{ value: prevmonth },,{ value: prevday },,{ value: prevyear }] = prevdateTimeFormat.formatToParts(tempdate )
//             fromDate = `${prevmonth} ${prevday} ${prevyear}`;
//         }else{
//             fromDate = ((String(this.state.from)).substring(4, 15));
//             toDate = ((String(this.state.to)).substring(4, 15));
//         }

//         console.log(fromDate);
//         console.log(toDate);
//         var maxValue = 0;

//         for(var i=0; i<dataR.length; i++){
//             var temp = {name: dataR[i].name, values:[]}
//             for(var j=0; j<dataR[i].values.length; j++){
//                 if(d3.timeParse("%Y-%m-%d")(dataR[i].values[j].date) >= d3.timeParse("%b %d %Y")(fromDate) &&
//                 d3.timeParse("%Y-%m-%d")(dataR[i].values[j].date) <= d3.timeParse("%b %d %Y")(toDate)){
//                     temp.values.push(dataR[i].values[j]);
//                     if(dataR[i].values[j].value > maxValue){
//                         maxValue = dataR[i].values[j].value
//                     }
//                 }
//             }
//             dataReady.push(temp)
//         }

//         console.log(dataReady)

//         // var allGroup = ["Product Management", "Human Resources", "Marketing", "Data", "Development"];
//         // var xBand = ["2020-06-01", "2020-06-08", "2020-06-15", "2020-06-22", "2020-07-29", "2020-07-06",
//         //             "2020-07-13", "2020-07-20", "2020-07-27", "2020-08-03",
//         //             "2020-08-10", "2020-08-17", "2020-08-24", "2020-08-31"]

//         var allGroup = dataReady.map(d => d.name)
//         var xBand = []
        
//         dataReady[0].values.forEach(function(item){
//             xBand.push(item.date)
//         })
//             // var myColor = d3.scaleOrdinal()
//             //     .domain(allGroup)
//             //     .range(["#98abc5", "#8a89a6", "#7b6888", "#6b486b", "#a05d56", "#d0743c", "#ff8c00"]);
        
//         var myColor = d3.scaleOrdinal()
//             .domain(allGroup)
//             .range(d3.schemeSet2);

//             var x = d3.scaleBand()
//                 .domain(xBand)
//                 .range([ 0, innerWidth ]);

//             // g.append("g")
//             //     .attr("transform", "translate(0," + innerHeight + ")")
//             //     .call(d3.axisBottom(x));

//             g.append("g")
//                 .attr("transform", "translate(0," + innerHeight + ")")
//                 .call(d3.axisBottom(x).tickSize(0))
//                 .selectAll("text")
//                   .style("text-anchor", "end")
//                   .attr("dx", "-.8em")
//                   .attr("dy", ".15em")
//                   .attr("transform", "rotate(-65)");

//             var y = d3.scaleLinear()
//                 .domain( [0,maxValue+1])
//                 .range([ innerHeight, 0 ]);
//             g.append("g")
//                 .call(d3.axisLeft(y));

//             var div = d3.select("body").append("div")	
//                 .attr("class", "tooltip")				
//                 .style("opacity", 0)
//                 .style("position", "absolute")
//                 .style("text-align", "center")
//                 .style("width", 60)
//                 .style("height", 28)
//                 .style("padding", 2)
//                 // .style("font", )
//                 .style("background", "lightsteelblue")
//                 .style("border", 0)
//                 .style("border-radius", 8)
//                 .style("pointer-events", 'none');

//             var line = d3.line()
//                 .x(function(d) { return x(d.date) })
//                 .y(function(d) { return y(+d.value) })
//             g.selectAll("myLines")
//                 .data(dataReady)
//                 .enter()
//                 .append("path")
//                     .attr("d", function(d){ return line(d.values) } )
//                     .attr("stroke", function(d){ return myColor(d.name) })
//                     .style("stroke-width", 4)
//                     .style("fill", "none")
                
//             g
//                     // First we need to enter in a group
//                 .selectAll("myDots")
//                 .data(dataReady)
//                 .enter()
//                     .append('g')
//                     .style("fill", function(d){ return myColor(d.name) })
//                     // Second we need to enter in the 'values' part of this group
//                 .selectAll("myPoints")
//                 .data(function(d){ return d.values })
//                 .enter()
//                 .append("circle")
//                     .attr("cx", function(d) { return x(d.date) } )
//                     .attr("cy", function(d) { return y(d.value) } )
//                     .attr("r", 5)
//                     .attr("stroke", "white")
//                 .on("mouseover", function(d) {		
//                         div.transition()		
//                             .duration(200)		
//                             .style("opacity", .9);		
//                         div.html("Date: " + (d.date) + "<br/>Number Polls: " + Number(d.value))	
//                             .style("left", (d3.event.pageX) + "px")		
//                             .style("top", (d3.event.pageY - 28) + "px");	
//                         })					
//                 .on("mouseout", function(d) {		
//                         div.transition()		
//                             .duration(200)		
//                             .style("opacity", 0);	
//                     })

//             // g
//             //     .selectAll("myLabels")
//             //     .data(dataReady)
//             //     .enter()
//             //         .append('g')
//             //         .append("text")
//             //             .datum(function(d) { return {name: d.name, value: d.values[d.values.length - 1]}; }) // keep only the last value of each time series
//             //             .attr("transform", function(d) { return "translate(" + x(d.value.date) + "," + y(d.value.value) + ")"; }) // Put the text at the position of the last point
//             //             .attr("x", 12) // shift the text a bit more right
//             //             .text(function(d) { return d.name; })
//             //             .style("fill", function(d){ return myColor(d.name) })
//             //             .style("font-size", 15)

//             g.selectAll("mydots")
//                 .data(allGroup)
//                 .enter()
//                 .append("circle")
//                 .attr("cx", 50 + innerWidth)
//                 .attr("cy", function(d,i){ return 20 + i*25}) // 100 is where the first dot appears. 25 is the distance between dots
//                 .attr("r", 10)
//                 .style("fill", function(d){ return myColor(d)})
            
//             g.selectAll("mylabels")
//             .data(allGroup)
//             .enter()
//             .append("text")
//               .attr("x", 70 + innerWidth)
//               .attr("y", function(d,i){ return 20 + i*25}) // 100 is where the first dot appears. 25 is the distance between dots
//               .style("fill", function(d){ return myColor(d)})
//               .text(function(d){ return d.charAt(0).toUpperCase() + d.slice(1)})
//               .attr("text-anchor", "left")
//               .style("alignment-baseline", "middle")
//               .style("font-size", 20)
          
        
//     }

//     render() {
//         return (
//             <div ref={this.myRef}></div>
//         )
//     }
// }


import React, {Component} from "react";
import {Runtime, Inspector, Library} from "@observablehq/runtime";
import notebook from "@namitmohale/multi-line-chart";
import axios from 'axios';
import * as d3 from 'd3';
import ReactToPdf from 'react-to-pdf';
// import ReactPDF, { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
// import html2canvas from 'html2canvas';
// import { jsPDF } from "jspdf";

class PollsChart extends Component {
    constructor(props){
        super(props);
        this.state = {
            url: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080',
            accessToken: localStorage.getItem('accessToken'),
            chartData : null,
            from: props.from,
            to: props.to,
            period: props.period,
            teams: props.teams,
            numPolls: 0
        }
    }
    animationRef = React.createRef();
    pdfRef = React.createRef();

    async getPolls(){
        if(this.state.period !== ''){
            var toDate = new Date()
            var fromDate = new Date();
            switch(this.state.period){
                case 1:
                    fromDate.setMonth(toDate.getMonth() - 3);
                    break;
                case 2:
                    fromDate.setMonth(toDate.getMonth() - 6);
                    break;
                case 3:
                    fromDate.setMonth(toDate.getMonth() - 9);
                    break;
                case 4:
                    fromDate.setMonth(toDate.getMonth() - 12);
                    break;
                default:
                    console.log("Date error!");
                    break;
            }
        }else{
            var toDate = new Date(this.state.to);
            var fromDate = new Date(this.state.from);
        }
        console.log("From: "+fromDate)
        console.log("To: "+toDate)
        var firstMonday = new Date(fromDate);
        firstMonday.setDate(firstMonday.getDate() + (8 - (firstMonday.getDay() || 7)) % 7);

        var dates = []
        while(firstMonday <= toDate){
            var tempDate = new Date(firstMonday)
            dates.push(tempDate);
            firstMonday.setDate(firstMonday.getDate() + 7)
        }
        await axios.post(this.state.url + '/poll/fetch/hr', {}, {
            headers: {'Authorization': `Bearer ${this.state.accessToken}`}
        }).then(response => {
            console.log(response);
            if(response.status === 200){
                if(response.data.length > 0){
                    var activePolls = response.data.filter(poll => {
                        return new Date(poll.endDate) > fromDate && new Date(poll.startDate) < toDate;
                    });
                    console.log("Active Polls: ")
                    console.log(activePolls)
                    this.setState({numPolls: activePolls.length})
                    var seriesList = []
                    var dataDict = {}
                    dates.forEach(monday => {
                        var mondayObj = {}
                        activePolls.forEach(poll => {
                            var teamsList = []
                            poll.teams.forEach(id => {
                                var teamObj = this.state.teams.filter(thisTeam => {
                                    return thisTeam._id === id
                                })[0]
                                teamsList.push(teamObj.name)
                            })
                            teamsList.forEach(team => {
                                if(new Date(poll.startDate) < monday && new Date(poll.endDate) > monday){
                                    if(team in mondayObj){
                                        mondayObj[team] += 1
                                    }else{
                                        mondayObj[team] = 1
                                    }
                                }else{
                                    mondayObj[team] = 0
                                }
                            })
                        })
                        Object.keys(mondayObj).forEach(key => {
                            if(key in dataDict){
                                dataDict[key].push(mondayObj[key])
                            }else{
                                dataDict[key] = [mondayObj]
                            }
                        })
                    })
                    
                    Object.keys(dataDict).forEach(key => {
                        seriesList.push({
                            name: key,
                            values: dataDict[key]
                        })
                    })
                    // console.log(seriesList)
                    // const parseDate = d3.utcParse("%Y-%m-%d")
                    console.log(dates.map(date => {
                        return String(date.getFullYear())+"-"+("0"+String(date.getMonth()+1)).slice(-2)+"-"+("0"+String(date.getDate())).slice(-2)
                    }))
                    this.setState({chartData: {
                        y: "Num Polls",
                        series: seriesList,
                        dates: dates.map(date => {
                            // return parseDate(String(date.getFullYear())+"-"+("0"+String(date.getMonth()+1)).slice(-2)+"-"+("0"+String(date.getDate())).slice(-2))
                            return String(date.getFullYear())+"-"+("0"+String(date.getMonth()+1)).slice(-2)+"-"+("0"+String(date.getDate())).slice(-2)
                        })
                    }})
                }
            }else{
                console.log("Response Status is not 200")
            }
        }).catch(error => {
            console.log(error)
        })
    }
  
    componentDidMount() {
        this.getPolls();
        const runtime = new Runtime().module(notebook, name => {
            if (name === "chart") {
                return new Inspector(this.animationRef.current);
            }
        });
        // runtime.redefine("width", 400)
        // runtime.redefine("height", "210mm")  
        runtime.redefine("dataR", this.state.chartData);
        runtime.redefine("titleFontSize", 15)    
    }

    componentDidUpdate(prevProps, prevState){
        if(prevState.chartData !== this.state.chartData){
            const runtime = new Runtime().module(notebook, name => {
                if (name === "chart") {
                return new Inspector(this.animationRef.current);
                }
            });
            // runtime.redefine("barTextSize", 6);
            // runtime.redefine("titleTextSize", 8);
            // runtime.redefine("barHeight", 25);
            // runtime.redefine("yAxisLabelSize", 6);
            runtime.redefine("dataR", this.state.chartData);
            runtime.redefine("titleFontSize", 15)    
            // runtime.redefine("width", 800);
            // runtime.redefine("xAxisLabelSize", 6);
            // runtime.redefine("margin", ({top: 60, right: 100, left: 90, bottom: 80}));
        }
    }
  
    render() {
        return (
            <div style={{padding: 20}}>
                <div ref={this.pdfRef}>
                    <div ref={this.animationRef} />
                </div>
                <ReactToPdf x={0} y={0} targetRef={this.pdfRef.current} filename="div-blue.pdf" height='800' options={{"orientation":'landscape', "format":'a4', margins : {
                                                                                                top: 0,
                                                                                                bottom: 0,
                                                                                                left: 0,
                                                                                                // height: 1000,
                                                                                                // width: '100%'
                                                                                                }}}>
                {({toPdf}) => (
                    <button onClick={toPdf}>Generate pdf</button>
                )}
            </ReactToPdf>
            </div>
        );
    }
  }
  
  export default PollsChart;